import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { beforeEach } from './guards';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

beforeEach(router);

// Gestion des meta tags dynamiques
router.afterEach((to) => {
  const title = to.meta.title || 'Suzuki 360 Viewer';
  const image = to.meta.image;

  // Mise à jour du title
  document.title = title;

  // Mise à jour de l'image Open Graph si présente
  if (image) {
    updateMetaTag('property', 'og:image', image);
    updateMetaTag('name', 'twitter:image', image);
  }
});

// Fonction utilitaire pour mettre à jour les meta tags
function updateMetaTag(attrName: string, attrValue: string, content: string) {
  let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  
  element.setAttribute('content', content);
}

export default router;

export * from './types';